<template>
  <div class="tglogindex">
    <el-table
      size="small"
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="supplier_name_top" label="上级供应商名称" />
      <el-table-column prop="supplier_name" label="供应商名称" />
      <el-table-column prop="ip" label="推广日志ID" />
      <el-table-column prop="addtime" label="添加时间">
        <template slot-scope="scope">
          {{
            formatDate(new Date(scope.row.addtime * 1000), "YY-MM-DD hh:mm:ss")
          }}
        </template>
      </el-table-column>
    </el-table>

    <div class="d-e-c" style="margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="pagination.curPage"
        :page-sizes="[10, 15, 20]"
        :page-size="pagination.per_page"
        layout="total, prev,sizes ,pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import PromotionApi from "@/api/promotion.js";

/**
 * 时间格式化工具
 * @param date 日期
 * @param format 格式
 * @returns string
 */
function formatDate(date, format) {
  if (!(date instanceof Date)) {
    throw new Error("请传递正确的Date对象");
  }

  const o = {
    YY: date.getFullYear(),
    MM: date.getMonth() + 1,
    DD: date.getDate(),
    hh: date.getHours(),
    mm: date.getMinutes(),
    ss: date.getSeconds()
  };

  return Object.keys(o).reduce((pre, key) => {
    return (pre = pre.replace(key, o[key] < 10 ? "0" + o[key] : o[key]));
  }, format);
}

const pagination = {
  per_page: 15,
  total: 1,
  curPage: 1
};

const originData = { tableData: [], loading: false, pagination };

async function initData(page, list_rows) {
  console.log(this.pagination)
  page = page ? page : this.pagination.curPage;
  list_rows = list_rows ? list_rows : this.pagination.per_page;
  const params = { page, list_rows };

  console.log(params)

  const {
    data: { data, current_page, last_page, per_page, total }
  } = await PromotionApi.getTglogList(params);

  this.tableData = data;
  this.pagination.total = total;
  this.pagination.curPage = current_page;
}

function handleCurrentChange(page) {
  this.initData(page);
}

function handleSizeChange(size) {
  const _ = undefined;
  this.initData(_, size);
}

export default {
  name: "Tglogindex",
  props: {},
  data() {
    return originData;
  },
  methods: {
    handleCurrentChange,

    handleSizeChange,

    formatDate,

    initData
  },
  created() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/promotion/promotion/tglogindex.vue